import { render, staticRenderFns } from "./DashboardSettingsBillingModalTitle.vue?vue&type=template&id=5b0d6d8d&"
import script from "./DashboardSettingsBillingModalTitle.vue?vue&type=script&lang=ts&"
export * from "./DashboardSettingsBillingModalTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports